import { createReducer } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

import {
  MESSAGES_LIST_RESET,
  MESSAGES_LIST_GET_START,
  MESSAGES_LIST_GET_SUCCESS,
  MESSAGES_LIST_GET_FAILURE,
} from './messagesList.const';

export const initialState = {
  model: {
    messages: [],
  },
  meta: {
    errorMessage: '',
    status: null,
    count: 0,
  },
};

const messagesListReducer = createReducer(initialState, builder => {
  builder
    .addCase(MESSAGES_LIST_RESET, () => initialState)
    .addCase(MESSAGES_LIST_GET_START, state => {
      state.meta.status = STATUS.LOADING;
      state.meta.errorMessage = '';
    })
    .addCase(MESSAGES_LIST_GET_SUCCESS, (state, { payload = {} }) => {
      state.model.messages = payload.messages;
      state.model.savedFilingPeriod = payload.savedFilingPeriod;
      state.meta.count = payload.count;
      state.meta.status = STATUS.SUCCESS;
    })
    .addCase(MESSAGES_LIST_GET_FAILURE, (state, { payload = {} }) => {
      state.model = {
        messages: [],
      };
      state.meta.count = 0;
      state.meta.errorMessage = payload.errorMessage;
      state.meta.status = STATUS.ERROR;
    })
    .addDefaultCase(() => {});
});

export default messagesListReducer;
